module.exports = __webpack_public_path__ + "static/media/arrow-left.0a82a114.svg";